// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settlementId: __t.u64().primaryKey().name("settlement_id"),
  lampsLit: __t.f32().name("lamps_lit"),
  lampsAt: __t.timestamp().name("lamps_at"),
  woodpile: __t.f32(),
  swept: __t.f32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
